import { useEffect, useState } from "react";
import axios from "axios";
import { Printer, Loader2 } from "lucide-react";
import { API } from "@/lib/reg";
import { Slip } from "./SuccessSlip";

export default function SlipPage({ regId }) {
  const [d, setD] = useState(undefined);
  useEffect(() => {
    axios.get(`${API}/slip/${regId}`).then((r) => setD(r.data)).catch(() => setD(null));
  }, [regId]);

  if (d === undefined) return <div className="py-24 grid place-items-center text-white"><Loader2 className="animate-spin" /></div>;
  if (d === null)
    return <p className="py-24 text-center text-white/80 font-hi" data-testid="slip-not-found">पर्ची नहीं मिली · Slip not found</p>;
  return (
    <>
      <div className="max-w-xl mx-auto px-4 py-8 no-print" data-testid="slip-page">
        <h1 className="text-center text-2xl font-bold text-white font-hi mb-4">पंजीकरण पर्ची · Registration Slip</h1>
        <Slip d={d} testid="public-slip" />
        <button onClick={() => window.print()} className="btn-saffron w-full justify-center mt-4" data-testid="slip-page-print-btn">
          <Printer size={18} /> PDF सेव / प्रिंट करें · Save PDF
        </button>
        <a href="/" className="block text-center text-white/60 text-sm mt-4" data-testid="slip-home-link">होम पेज · Home</a>
      </div>
      <div className="print-only"><Slip d={d} testid="public-slip-print" /></div>
    </>
  );
}
